import { CartLinesUpdateEvent } from '@shopify/events';

const tl = (kurus) => {
  const n = Math.round(kurus) / 100;
  return n.toLocaleString('tr-TR', { minimumFractionDigits: Number.isInteger(n) ? 0 : 2, maximumFractionDigits: 2 }) + ' ₺';
};

class FitDayUrun {
  constructor(kok) {
    this.kok = kok;
    this.veri = JSON.parse(kok.querySelector('[data-fd-veri]').textContent);
    this.veri.tablo = this.veri.tablo.filter((t) => t.b);
    this.$ = (s) => kok.querySelector(s);
    this.$$ = (s) => [...kok.querySelectorAll(s)];
    // Reklam linki paketi seçebilir: ?paket=tek | 3lu | 5li (yoksa şablondaki varsayılan, 3'lü). Merkez 10-21 (C3 → ?paket=5li).
    const istenen = { tek: '1', '1': '1', '3lu': '3', '3': '3', '5li': '5', '5': '5' }[(new URLSearchParams(location.search).get('paket') || '').toLowerCase()];
    const urlPaket = istenen && this.$(`[data-paket][data-adet="${istenen}"]`);
    if (urlPaket) this.$$('[data-paket]').forEach((x) => { x.classList.toggle('is-on', x === urlPaket); x.setAttribute(x.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', x === urlPaket ? 'true' : 'false'); });
    const ilkPaket = urlPaket || this.$('[data-paket].is-on') || this.$('[data-paket]');
    this.paket = this.paketOku(ilkPaket);
    this.renk = this.$('[data-renk-grup="ust"] .is-on')?.dataset.renk || this.veri.renkler && Object.keys(this.veri.renkler)[0];
    this.beden = null;
    this.satirlar = [];
    this.acikSatir = -1;
    this.kartMod = !!this.$('[data-paket-icerik]');  // v4: renk/beden seçili paket kartının içinde
    this.eksikIsaret = false;
    this.kur();
    this.satirlariKur();
    this.ciz();
  }

  paketOku(el) {
    return { el, adet: +el.dataset.adet, ode: +el.dataset.ode, toplam: +el.dataset.toplam, adetbasi: +el.dataset.adetbasi };
  }

  kur() {
    this.$$('[data-paket]').forEach((el) => {
      const sec = () => {
        if (this.paket.el === el) return;
        this.$$('[data-paket]').forEach((x) => { x.classList.toggle('is-on', x === el); x.setAttribute(this.kartMod ? 'aria-checked' : 'aria-pressed', x === el ? 'true' : 'false'); });
        this.paket = this.paketOku(el);
        this.satirlariKur();
        this.ciz();
      };
      // kartın içindeki renk/beden listelerine dokunmak paketi değiştirmez
      el.addEventListener('click', (e) => { if (!e.target.closest('[data-paket-icerik]')) sec(); });
      el.addEventListener('keydown', (e) => { if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('[data-paket-icerik]')) { e.preventDefault(); sec(); } });
    });
    this.$$('[data-renk-grup="ust"] [data-renk]').forEach((el) =>
      el.addEventListener('click', () => { this.renk = el.dataset.renk; this.satirlar.forEach((s) => (s.renk = this.renk)); this.galeriRenk(this.renk); this.ciz(); })
    );
    this.$$('[data-beden-grup="ust"] [data-beden]').forEach((el) =>
      el.addEventListener('click', () => this.bedenSec(el.dataset.beden))
    );
    this.$('[data-sepete]').addEventListener('click', () => this.sepete());
    this.galeriKur();
    this.bulucuKur();
    this.sabitKur();
    this.teslimKur();
    this.codKur();
    this.videoKur();
  }

  videoKur() {
    // Videolar LCP/FCP ile yarışmasın (Lighthouse 10-21: autoplay 1,8 MB'ı hemen indiriyordu): sayfa yüklendikten ve tarayıcı boşaldıktan
    // SONRA, yalnız ekrandaki video oynar. O zamana kadar poster görseli (fetchpriority=high) görünür.
    const vids = this.$$('.fd-galeri__kare--video video');
    if (!vids.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { vids.forEach((v) => { v.controls = true; }); return; }
    if (!('IntersectionObserver' in window)) return;
    const basla = () => {
      const io = new IntersectionObserver((es) => es.forEach((e) => { const v = e.target; if (e.isIntersecting) { v.preload = 'auto'; v.play().catch(() => {}); } else v.pause(); }), { threshold: 0.35 });
      vids.forEach((v) => io.observe(v));
    };
    const sonra = () => ('requestIdleCallback' in window ? requestIdleCallback(basla, { timeout: 3000 }) : setTimeout(basla, 1500));
    document.readyState === 'complete' ? sonra() : window.addEventListener('load', sonra, { once: true });
  }

  bedenSec(b) {
    this.beden = b;
    this.satirlar.forEach((s) => (s.beden = b));
    this.eksikIsaret = false;
    const u = this.$('[data-beden-uyari]'); if (u) u.hidden = true;
    this.ciz();
  }

  satirlariKur() {
    const eski = this.satirlar;
    const ilk = eski[0] || { renk: this.renk, beden: this.beden };
    this.satirlar = Array.from({ length: this.paket.adet }, (_, i) => eski[i] || { renk: ilk.renk, beden: ilk.beden });
    this.acikSatir = -1;
  }

  varyant(renk, beden) {
    return this.veri.varyant.find((v) => v.renk === renk && (v.beden ?? null) === (beden ?? null));
  }

  ciz() {
    const { adet, ode, toplam, adetbasi } = this.paket;
    const yaz = (sel, t) => { const e = this.$(sel); if (e) e.textContent = t; };
    yaz('[data-adet-yaz]', adet);
    yaz('[data-renk-yaz]', this.renk);
    yaz('[data-beden-yaz]', this.beden || 'seç');
    const bedenli = this.veri.bedenler.length > 0;
    this.$$('[data-renk-grup="ust"] [data-renk]').forEach((x) => x.classList.toggle('is-on', x.dataset.renk === this.renk));
    this.$$('[data-beden-grup="ust"] [data-beden]').forEach((x) => x.classList.toggle('is-on', x.dataset.beden === this.beden));

    const kap = this.$('[data-satirlar]');
    if (this.kartMod) this.kartCiz();
    if (kap) {
    kap.innerHTML = '';
    this.$('[data-satir-not]').hidden = adet < 2;
    kap.hidden = adet < 2;
    this.satirlar.forEach((s, i) => {
      const hediye = i >= ode;
      const r = document.createElement('div');
      r.className = 'fd-satir' + (hediye ? ' is-hediye' : '') + (i === this.acikSatir ? ' is-acik' : '');
      r.innerHTML = `
        <div class="fd-satir__ust">
          <span class="fd-satir__no">${i + 1}</span>
          <span class="fd-satir__sw" style="--sw:${this.veri.renkler[s.renk] || '#ccc'}"></span>
          <span class="fd-satir__ad">${s.renk}${bedenli ? ' · ' + (s.beden ? s.beden : '<em>beden seç</em>') : ''}</span>
          ${hediye ? '<span class="fd-rozet-hediye">HEDİYE</span>' : ''}
          <button type="button" class="fd-link fd-satir__degis" aria-expanded="${i === this.acikSatir}">${i === this.acikSatir ? 'Tamam' : 'Değiştir'}</button>
        </div>
        ${i === this.acikSatir ? `<div class="fd-satir__alt">
          <div class="fd-renkler fd-renkler--kucuk">${Object.entries(this.veri.renkler).map(([ad, hex]) => this.veri.yazi_secenek ? `<button type="button" class="fd-beden fd-model${ad === s.renk ? ' is-on' : ''}" data-r="${ad}">${ad}</button>` : `<button type="button" class="fd-renk${ad === s.renk ? ' is-on' : ''}" data-r="${ad}" aria-label="${ad}" title="${ad}" style="--sw:${hex}">${ad.includes('Cepli') ? '<i class="fd-cep"></i>' : ''}</button>`).join('')}</div>
          ${bedenli ? `<div class="fd-bedenler fd-bedenler--kucuk">${this.veri.bedenler.map((b) => `<button type="button" class="fd-beden${b === s.beden ? ' is-on' : ''}" data-b="${b}">${b}</button>`).join('')}</div>` : ''}
        </div>` : ''}`;
      r.querySelector('.fd-satir__degis').addEventListener('click', () => { this.acikSatir = this.acikSatir === i ? -1 : i; this.ciz(); });
      r.querySelectorAll('[data-r]').forEach((b) => b.addEventListener('click', () => { s.renk = b.dataset.r; this.ciz(); }));
      r.querySelectorAll('[data-b]').forEach((b) => b.addEventListener('click', () => { s.beden = b.dataset.b; this.ciz(); }));
      kap.appendChild(r);
    });
    }

    const ust = this.$('.fd-fiyat-ust');
    // v4b: fiyat TEK satır — "1.498 ₺ · 3 gömlek, 1'i hediye" (tek gömlekte "+ kargo")
    const hedS = adet - ode, ek = hedS === 1 ? "'i" : hedS === 2 ? "'si" : "'i";
    if (ust) ust.innerHTML = `<b>${tl(toplam)}</b> · ${adet} gömlek${hedS > 0 ? `, ${hedS}${ek} hediye` : ` <span>+ ${tl(this.veri.kargo)} kargo</span>`}`;
    const kargoUcret = ode < adet ? 0 : this.veri.kargo;
    this.$('[data-kargo-yaz]').innerHTML = kargoUcret ? `+ ${tl(kargoUcret)}` : `<s>${tl(this.veri.kargo)}</s> <b class="fd-yesil">Ücretsiz</b>`;
    this.$('[data-toplam-yaz]').textContent = tl(toplam);
    this.$('[data-adetbasi-yaz]').textContent = adet > 1 ? `tanesi ${tl(Math.round(adetbasi / 100) * 100)}` : '';
    const hed = adet - ode;
    this.$('[data-kazanc-yaz]').innerHTML = hed > 0 ? `${render(hed)} gömlek hediye, kargo bizden.` : (this.veri.tek_not || '');
    function render(n) { return `<b>${n}</b>`; }
    const sf = this.$('[data-sabit-fiyat]');
    if (sf) { sf.textContent = tl(toplam); this.$('[data-sabit-alt]').textContent = `${adet > 1 ? adet + ' gömlek · ' : ''}kapıda öde${ode < adet ? ' · kargo bedava' : ''}`; }
    this.codGuncelle();
  }

  // EasySell COD: paketin tüm satırları (karışık renk/beden) EasySell'in bundle kancasından geçer.
  // EasySell addVariantToCart(): window.pmpr_cart_item doluysa sepeti boşaltıp TAM bu kalemleri ekler, formu sepetle açar.
  kalemler() {
    const bedenli = this.veri.bedenler.length > 0;
    if (bedenli && this.satirlar.some((s) => !s.beden)) return null;
    const sayac = new Map();
    for (const s of this.satirlar) {
      const v = this.varyant(s.renk, bedenli ? s.beden : null);
      if (!v) return null;
      sayac.set(v.id, (sayac.get(v.id) || 0) + 1);
    }
    return [...sayac].map(([id, quantity]) => ({ id, quantity, properties: { _paket: `${this.paket.adet} ${this.kartMod ? "gömlek" : "adet"}` } }));
  }

  codGuncelle() {
    if (!this.$('[data-cod]')) return;
    const k = this.kalemler();
    if (k) window.pmpr_cart_item = k; else delete window.pmpr_cart_item;
  }

  codKur() {
    const cod = this.$('[data-cod]');
    if (!cod) return;
    // Beden seçilmeden EasySell formu açılmasın: EasySell'in kendi dinleyicisinden ÖNCE (window capture) yakala.
    window.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('.es-popup-button');
      if (!b || b.classList.contains('es-popup-button-drawer') || b.classList.contains('es-popup-button-cart') || !this.kok.contains(b)) return;
      this.codGuncelle();
      if (window.pmpr_cart_item) return;
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      this.eksikGoster();
    }, true);
    // EasySell butonu inline "!important" renk taşır (panel cpbStyle) → marka rengine JS ile çevir.
    const boya = () => cod.querySelectorAll('.es-popup-button').forEach((b) => {
      if (b.dataset.fdBoya) return; b.dataset.fdBoya = '1';
      [['background', '#B5472A'], ['border-radius', '10px'], ['min-height', '60px'], ['box-shadow', '0 6px 18px rgba(181,71,42,.28)'], ['font-size', '16px'], ['font-weight', '800']].forEach(([k, v]) => b.style.setProperty(k, v, 'important'));
    });
    new MutationObserver(boya).observe(cod, { childList: true, subtree: true }); boya();
    // EasySell butonu 5 sn içinde gelmezse Sepete ekle ana buton olur (form yine çalışmazsa satış kaçmasın).
    setTimeout(() => { if (!cod.querySelector('.es-popup-button')) { const b = this.$('[data-sepete]'); b.classList.remove('fd-btn--ikincil'); b.classList.add('fd-btn--ana'); cod.hidden = true; } }, 5000);
  }

  // v4: seçili paket kartının içinde her gömleğe bir satır: renk noktası + renk listesi + beden listesi
  kartCiz() {
    const { adet, ode } = this.paket;
    this.$$('[data-paket-icerik]').forEach((x) => { if (x !== this.paket.el.querySelector('[data-paket-icerik]')) x.innerHTML = ''; });
    const ic = this.paket.el.querySelector('[data-paket-icerik]');
    if (!ic) return;
    const bedenli = this.veri.bedenler.length > 0;
    const renkler = Object.keys(this.veri.renkler);
    const kac = (i) => (adet > 1 ? `${i + 1}. gömlek` : 'Gömlek');
    ic.innerHTML = this.satirlar.map((s, i) => `
      <div class="fd-sr${i >= ode ? ' is-hediye' : ''}${bedenli && !s.beden && this.eksikIsaret ? ' is-eksik' : ''}">
        <span class="fd-sr__no">${adet > 1 ? i + 1 : ''}</span>
        <label class="fd-sr__renk"><i style="--sw:${this.veri.renkler[s.renk] || '#ccc'}"></i><select data-r="${i}" aria-label="${kac(i)} rengi">${renkler.map((ad) => `<option${ad === s.renk ? ' selected' : ''}>${ad}</option>`).join('')}</select></label>
        ${bedenli ? `<select class="fd-sr__beden" data-b="${i}" aria-label="${kac(i)} bedeni"><option value="">Beden</option>${this.veri.bedenler.map((b) => `<option${b === s.beden ? ' selected' : ''}>${b}</option>`).join('')}</select>` : ''}
        ${i >= ode ? '<span class="fd-sr__hediye">Hediye</span>' : ''}
      </div>`).join('');
    ic.querySelectorAll('[data-r]').forEach((el) => el.addEventListener('change', () => { const i = +el.dataset.r; this.satirlar[i].renk = el.value; if (i === 0) this.galeriRenk(el.value); this.ciz(); }));
    ic.querySelectorAll('[data-b]').forEach((el) => el.addEventListener('change', () => {
      const i = +el.dataset.b; const v = el.value || null;
      this.satirlar[i].beden = v;
      if (v) this.satirlar.forEach((x, j) => { if (j > i && !x.beden) x.beden = v; });  // seçilen beden boş kalan satırlara iner
      if (!this.satirlar.some((x) => !x.beden)) { this.eksikIsaret = false; const u = this.$('[data-beden-uyari]'); if (u) u.hidden = true; }
      this.ciz();
    }));
  }

  eksikGoster() {
    const eksik = this.veri.bedenler.length ? this.satirlar.findIndex((s) => !s.beden) : -1;
    this.$('[data-beden-uyari]').hidden = false;
    if (this.kartMod) {
      this.eksikIsaret = true; this.ciz();
      (this.paket.el.querySelector('.fd-sr.is-eksik .fd-sr__beden') || this.paket.el).scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!this.beden || eksik < 0) this.$('[data-beden-adim]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else { this.acikSatir = eksik; this.ciz(); this.$('.fd-satir.is-acik')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  async sepete() {
    const btn = this.$('[data-sepete]');
    const hata = this.$('[data-hata]');
    hata.hidden = true;
    const eksik = this.veri.bedenler.length ? this.satirlar.findIndex((s) => !s.beden) : -1;
    if (eksik > -1) { this.eksikGoster(); return; }
    const sayac = new Map();
    for (const s of this.satirlar) {
      const v = this.varyant(s.renk, this.veri.bedenler.length ? s.beden : null);
      if (!v) { hata.textContent = 'Bu renk/beden şu an seçilemiyor, başka bir seçim yap.'; hata.hidden = false; return; }
      sayac.set(v.id, (sayac.get(v.id) || 0) + 1);
    }
    const items = [...sayac].map(([id, quantity]) => ({ id, quantity, properties: { _paket: `${this.paket.adet} ${this.kartMod ? "gömlek" : "adet"}` } }));
    const bolumler = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
    btn.disabled = true; btn.classList.add('is-yukleniyor');
    const ertelenen = CartLinesUpdateEvent.createPromise();
    this.kok.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })), promise: ertelenen.promise }));
    try {
      const yanit = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: bolumler.join(',') }),
      }).then((r) => r.json());
      const sepet = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
      const detail = { items: sepet.items, source: 'fitday-paket', sourceId: this.kok.id, itemCount: this.paket.adet, productId: String(this.veri.urun), sections: yanit.sections, didError: Boolean(yanit.status) };
      ertelenen.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet), detail });
      if (yanit.status) { hata.textContent = yanit.description || yanit.message || 'Sepete eklenemedi, tekrar dene.'; hata.hidden = false; return; }
      if (!document.querySelector('cart-drawer-component')) window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (e) {
      ertelenen.reject(e);
      hata.textContent = 'Bağlantı sorunu oldu, tekrar dene.'; hata.hidden = false;
    } finally {
      btn.disabled = false; btn.classList.remove('is-yukleniyor');
    }
  }

  galeriKur() {
    const ana = this.$('[data-galeri-ana]');
    if (!ana) return;
    const kareler = [...ana.children];
    const noktalar = this.$$('.fd-galeri__nokta span');
    const kucukler = this.$$('[data-kucuk]');
    const isaretle = (i) => { noktalar.forEach((n, j) => n.classList.toggle('is-on', i === j)); kucukler.forEach((n, j) => n.classList.toggle('is-on', i === j)); };
    ana.addEventListener('scroll', () => { const i = Math.round(ana.scrollLeft / ana.clientWidth); isaretle(i); }, { passive: true });
    kucukler.forEach((k, i) => k.addEventListener('click', () => { ana.scrollTo({ left: kareler[i].offsetLeft - ana.offsetLeft, behavior: 'smooth' }); isaretle(i); }));
    this.galeriGit = (mediaId) => { const i = kareler.findIndex((k) => k.dataset.mediaId === String(mediaId)); if (i > -1) { ana.scrollTo({ left: kareler[i].offsetLeft - ana.offsetLeft, behavior: 'smooth' }); isaretle(i); } };
  }

  galeriRenk(renk) {
    const v = this.veri.varyant.find((x) => x.renk === renk && x.media);
    if (v && this.galeriGit) this.galeriGit(v.media);
  }

  bulucuKur() {
    const dlg = this.$('[data-bulucu]');
    if (!dlg) return;
    // v4c: sayfada beden tablosu bölümü varsa "Bedenimi bul" oraya kaydırır; yoksa pencere açılır
    this.$('[data-bulucu-ac]').addEventListener('click', () => { const b = document.getElementById('fd-beden'); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'start' }); else dlg.showModal(); });
    let oneri = null;
    this.$('[data-bulucu-hesap]').addEventListener('click', () => {
      const boy = +this.$('[data-boy]').value, kilo = +this.$('[data-kilo]').value;
      const gobek = +(dlg.querySelector('input[type=radio]:checked')?.value || 0);
      if (!boy || !kilo || boy < 150 || boy > 205 || kilo < 45 || kilo > 160) { this.$('[data-bulucu-ek]').textContent = ''; this.$('[data-bulucu-sonuc]').hidden = true; const g = this.$('[data-boy]'); g.setCustomValidity(!boy || boy < 150 || boy > 205 ? 'Boyu 150-205 cm arası yaz' : ''); this.$('[data-kilo]').setCustomValidity(!kilo || kilo < 45 || kilo > 160 ? 'Kiloyu 45-160 kg arası yaz' : ''); this.$('[data-bulucu-form]').reportValidity(); return; }
      this.$('[data-boy]').setCustomValidity(''); this.$('[data-kilo]').setCustomValidity('');
      const t = this.veri.tablo;
      let i = t.findIndex((s) => kilo <= s.kilo);
      if (i < 0) i = t.length - 1;
      if (boy > t[i].boy && i < t.length - 1) i++;
      let ek = '';
      if (gobek && i < t.length - 1) { i++; ek = 'Göbek belirgin olduğu için bir üst bedeni önerdik.'; }
      if (kilo > t[t.length - 1].kilo) ek = 'Tablonun üst sınırındasın; emin olmak için bize yaz, ölçüye bakalım.';
      oneri = t[i].b;
      this.$('[data-bulucu-beden]').textContent = oneri;
      this.$('[data-bulucu-ek]').textContent = ek || 'Olmazsa sorun değil: 30 gün içinde ücretsiz değiştiriyoruz.';
      this.$('[data-bulucu-sonuc]').hidden = false;
    });
    this.$('[data-bulucu-sec]').addEventListener('click', () => { if (oneri) this.bedenSec(oneri); dlg.close(); });
  }

  sabitKur() {
    const sabit = this.$('[data-sabit]');
    const hedef = this.$('[data-sepete]');
    if (!sabit || !hedef || !('IntersectionObserver' in window)) return;
    const hep = sabit.classList.contains('fd-sabit--hep');
    const paket = this.$('.fd-paketler') || hedef;
    const goster = (g) => { sabit.classList.toggle('is-gorunur', g); sabit.setAttribute('aria-hidden', g ? 'false' : 'true'); this.$('[data-sabit-btn]').tabIndex = g ? 0 : -1; };
    // hep: satın alma kutusu, son çağrı ya da alt bilgi ekrandayken gizli (çift CTA olmasın, alt bilgi örtülmesin)
    const gorunen = new Set();
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => (e.isIntersecting ? gorunen.add(e.target) : gorunen.delete(e.target)));
      // v4c: paket kutusu ekrandan YUKARI çıkınca belirir (ilk ekranda paket zaten görünür)
      if (hep) goster(gorunen.size === 0 && paket.getBoundingClientRect().top < 0);
      else { const e = es.find((x) => x.target === hedef); if (e) goster(!e.isIntersecting && e.boundingClientRect.top < 0); }
    });
    io.observe(hedef);
    if (hep) [paket, this.$('[data-cod]'), document.querySelector('.fd-son'), document.querySelector('footer, .shopify-section-group-footer-group')].filter(Boolean).forEach((x) => io.observe(x));
    this.$('[data-sabit-btn]').addEventListener('click', () => {
      // beden seçiliyse tek dokunuşla kapıda ödeme formu; değilse paket/beden adımına götür
      const es = this.$('.fd-cod .es-popup-button');
      if (es && this.kalemler()) { this.codGuncelle(); es.click(); return; }
      if (this.kalemler() === null && this.veri.bedenler.length && this.satirlar.some((x) => !x.beden)) { this.eksikGoster(); return; }
      (this.$('.fd-paketler') || this.$('[data-kutu]')).scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
}

// Tahmini teslim: bugün + 1…3 iş günü (Furkan 10-22); hafta sonu ve sabit tarihli resmî tatiller atlanır (dini bayramlar listede yok).
FitDayUrun.prototype.teslimKur = function () {
  const el = this.$('[data-teslim]');
  if (!el) return;
  const tatil = ['01-01', '04-23', '05-01', '05-19', '07-15', '08-30', '10-29'];
  const isGunu = (d) => d.getDay() % 6 !== 0 && !tatil.includes(`${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`);
  const ekle = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (isGunu(d)) k++; } return d; };
  const ay = (d) => d.toLocaleDateString('tr-TR', { month: 'long' });
  const a = ekle(1), b = ekle(3);
  el.querySelector('span').textContent = `Tahmini teslim: ${a.getDate()}${ay(a) === ay(b) ? '' : ' ' + ay(a)}–${b.getDate()} ${ay(b)}`;
  el.hidden = false;
};

const baslat = () => document.querySelectorAll('.fd-urun:not([data-hazir])').forEach((k) => { k.dataset.hazir = '1'; new FitDayUrun(k); });
baslat();
document.addEventListener('shopify:section:load', baslat);
